import { t } from "@/i18n-js/instance";
import { AiAgents } from "./AiAgents";
import { ApiAddons } from "./ApiAddons";
import { Characteristics } from "./Characteristics";
import { Community } from "./Community";
import { CommunityAddons } from "./CommunityAddons";
import { CommunityAi } from "./CommunityAi";
import { Heading } from "./Heading";
import { LiveStreams } from "./LiveStreams";
import { LiveStreamsAddons } from "./LiveStreamsAddons";
import { Services } from "./Services";
import { Sso } from "./Sso";
import { Support } from "./Support";
import { Workflows } from "./Workflows";

export const Features = () => (
  <div>
    <Heading>{t("plans.index.usage")}</Heading>
    <Community />
    <Workflows />
    <LiveStreams />
    <Characteristics />
    <CommunityAi />
    <AiAgents />
    <Heading>{t("settings.billing.add_ons.title")}</Heading>
    <CommunityAddons />
    <ApiAddons />
    <LiveStreamsAddons />
    <Sso />
    <Support />
    <Services />
  </div>
);
